import { render, staticRenderFns } from "./AppointmentReportDetailsSidebar.vue?vue&type=template&id=35c472e9"
import script from "./AppointmentReportDetailsSidebar.vue?vue&type=script&lang=js"
export * from "./AppointmentReportDetailsSidebar.vue?vue&type=script&lang=js"
import style0 from "./AppointmentReportDetailsSidebar.vue?vue&type=style&index=0&id=35c472e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports